import { themeColors } from "../../config";

export const appExplorerStyles = {
  frame: {
    backgroundColor: themeColors.transparentWhite,
    position: "absolute",
    bottom: 0,
    justifyContent: "center",
    display: "flex",
    alignItems: "center",
    overflow: "hidden",
    transition: "width 0.2s, height 0.2s, opacity 0.1s",
    zIndex: 9,
  },

  container: {
    width: "80%",
    height: "80%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "center",
    backgroundColor: themeColors.transparentBlack,
    borderRadius: 20,
    margin: 50,
  },

  appContainer: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    maxWidth: 800,
    transition: "width 0.2s",
  },
  icon: {
    height: "100%",
    width: "100%",
    borderRadius: "50%",
  },
  title: {
    fontSize: 24,
    color: themeColors.optionTextColor,
    fontFamily: "roboto",
    margin: 10,
    textShadow: "0 0 5px white",
  },
  exitBtn: {
    position: "absolute",
    bottom: 10,
    width: 50,
    height: 50,
    borderRadius: 25,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: themeColors.transparentBlack,
  },
};
